import { request } from "../utils/request.js"

export const customizeInputOrder_exportForManage = (pojo, args) => request({
    url: 'customizeInputOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageForManage = (pojo, args) => request({
    url: 'customizeInputOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageListForManage = (pojo, args) => request({
    url: 'customizeInputOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageForDeliveryManage = (pojo, args) => request({
    url: 'customizeInputOrder/findPageForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageListForDeliveryManage = (pojo, args) => request({
    url: 'customizeInputOrder/findPageListForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageForCurrentUserDelivery = (pojo, args) => request({
    url: 'customizeInputOrder/findPageForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageListForCurrentUserDelivery = (pojo, args) => request({
    url: 'customizeInputOrder/findPageListForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'customizeInputOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'customizeInputOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_saveIntoDraft = (pojo, args) => request({
    url: 'customizeInputOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeInputOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'customizeInputOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeInputOrder_update = (pojo, args) => request({
    url: 'customizeInputOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeInputOrder_updateAndSubmit = (pojo, args) => request({
    url: 'customizeInputOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeInputOrder_submitById = (id, args) => request({
    url: 'customizeInputOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const customizeInputOrder_deleteById = (id, args) => request({
    url: 'customizeInputOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeInputOrder_approval = (pojo, args) => request({
    url: 'customizeInputOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeInputOrder_findById = (id, args) => request({
    url: 'customizeInputOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_findVoById = (id, args) => request({
    url: 'customizeInputOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeInputOrder_generatePrintPdf = (pojo, args) => request({
    url: 'customizeInputOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/customizeInputOrder.js